const initialState = {
  currentUser: {
    email: null
  },
  token: null,
  notices: [],
  buttonLoading: false,
  categories: [
    'Information Technology',
    'Education',
    'Finance',
    'E-Commerce',
    'Web Application',
    'Cooperate',
    'Personal',
    'Medical'
  ],
  pageLoading: false,
  progressPercentage: 0,
  progressLoading: false
}

export default (state = initialState, action) => {
  switch (action.type) {

    case 'SET_CURRENT_USER':
      return {
        ...state,
        currentUser: action.user
      }

    case 'LOGOUT':
      return {
        ...state,
        currentUser: {}
      }

    case 'SHOW_BTN_LOADING':
      return {
        ...state,
        buttonLoading: true
      }

    case 'HIDE_BTN_LOADING':
      return {
        ...state,
        buttonLoading: false
      }


    case 'SET_AUTH_TOKEN':
      return {
        ...state,
        token: action.token
      }


    case 'SHOW_PAGE_LOADING':
      return {
        ...state,
        pageLoading: true
      }

    case 'HIDE_PAGE_LOADING':
      return {
        ...state,
        pageLoading: false
      }

    case 'SHOW_PROGRESS_PAGE_LOADING':
      return {
        ...state,
        progressLoading: true
      }

    case 'HIDE_PROGRESS_PAGE_LOADING':
      return {
        ...state,
        progressLoading: false
      }

    case 'PROGRESS_START':
      return {
        ...state,
        progressPercentage: action.percentage
      }
    case 'PROGRESS_END':
      return {
        ...state,
        progressPercentage: 0
      }

    default:
      return state
  }
}
